import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Stack, TextField } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { ModalLayout } from '@/components'

type EditRoundNameModalProps = {
  currentName: string
  onSubmit: (newName: string) => void
  isLoading: boolean
  onClose: () => void
}

export const EditRoundNameModal = ({
  currentName,
  onSubmit,
  isLoading,
  onClose,
}: EditRoundNameModalProps) => {
  const { t } = useTranslation('monitoring')
  const [name, setName] = useState(currentName)

  return (
    <ModalLayout
      title={t('titles.editRoundName')}
      footerActions={
        <Stack
          direction="row"
          spacing={2}
          justifyContent="flex-end"
          width="100%"
        >
          <Button onClick={onClose} disabled={isLoading}>
            {t('common:buttons.cancel')}
          </Button>
          <LoadingButton
            variant="contained"
            onClick={() => onSubmit(name)}
            loading={isLoading}
          >
            {t('common:buttons.save')}
          </LoadingButton>
        </Stack>
      }
    >
      <Box p={4}>
        <TextField
          fullWidth={true}
          label={t('placeholders.roundName')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus={true}
        />
      </Box>
    </ModalLayout>
  )
}
